import { renderRoot } from 'quartz-core/client';
import AppComponent from './AppComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const setupApp = (store, history) => {
  renderRoot( /*#__PURE__*/_jsx(AppComponent, {
    history: history,
    store: store
  }));
};